module.exports = __webpack_public_path__ + "static/media/MasterCard.d92ea72e.svg";